import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, inject, Injectable, Signal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { tapResponse } from '@ngrx/operators';
import { Observable, switchMap } from 'rxjs';
import { TScwAppModules } from './scw-app-switcher.interface';
import { ELoadStatus } from '../../../constants.model';
import { BaseOneResponseInterface } from '../../shared/model/interface/crud-response-interface.model';

export interface IScwAppSwitcherComponentState {
  data: TScwAppModules;
  dataLoading: ELoadStatus;
}

@Injectable()
export class ScwAppSwitchersStore extends ComponentStore<IScwAppSwitcherComponentState> {
  readonly isLoading$: Signal<boolean> = this.selectSignal(
    (state: IScwAppSwitcherComponentState) => state.dataLoading === ELoadStatus.Loading,
  );
  readonly data$: Signal<TScwAppModules> = this.selectSignal((state: IScwAppSwitcherComponentState) => state.data);

  readonly getUrls = this.effect((trigger$: Observable<void>) =>
    trigger$.pipe(
      switchMap(() => {
        this.patchState({ dataLoading: ELoadStatus.Loading });

        return this.getUrlsFromOEE().pipe(
          tapResponse(
            (response) =>
              this.patchState({
                data: response.data,
                dataLoading: ELoadStatus.Success,
              }),
            () => {
              this.patchState({ dataLoading: ELoadStatus.Failure });
            },
          ),
        );
      }),
    ),
  );

  constructor(
    @Inject('API_BASE_URL')
    private readonly baseUrl: string,
    private readonly http: HttpClient,
  ) {
    super({
      data: {
        actionTracker: undefined,
        digitalBoards: undefined,
        digitalLogbook: undefined,
        oeeTracker: undefined,
      } as TScwAppModules,
      dataLoading: ELoadStatus.Initial,
    });
  }

  private getUrlsFromOEE(): Observable<BaseOneResponseInterface<TScwAppModules>> {
    return this.http.get<BaseOneResponseInterface<TScwAppModules>>(`${this.baseUrl}/users/scw-app-module-urls`);
  }
}
